import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "20",
  height: "18",
  fill: "none",
  viewBox: "0 0 20 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { "clip-path": "url(#a)" }, [
      _createElementVNode("path", {
        stroke: "#44403C",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        "stroke-width": "1.67",
        d: "M1 6.187c0-1.047.304-2.068.871-2.93a4.991 4.991 0 0 1 2.307-1.9A4.75 4.75 0 0 1 7.11 1.16 4.914 4.914 0 0 1 9.632 2.73a.505.505 0 0 0 .368.167.485.485 0 0 0 .368-.167 4.907 4.907 0 0 1 2.522-1.584c.976-.248 2-.18 2.937.196a4.982 4.982 0 0 1 2.31 1.905c.567.866.868 1.891.863 2.94 0 2.153-1.35 3.761-2.7 5.171l-4.943 4.996a1.81 1.81 0 0 1-.606.474 1.736 1.736 0 0 1-1.482.01 1.805 1.805 0 0 1-.612-.466L3.7 11.358C2.35 9.948 1 8.35 1 6.187Z"
      })
    ], -1),
    _createElementVNode("defs", null, [
      _createElementVNode("clipPath", { id: "a" }, [
        _createElementVNode("path", {
          fill: "#fff",
          d: "M0 0h20v18H0z"
        })
      ])
    ], -1)
  ]))]))
}
export default { render: render }